import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import { BillProcessingStatus } from 'src/domain/customer-utility-bill/interface';

dayjs.extend(quarterOfYear);

export interface IBillSidebarFilters {
    period: string | null;
    statuses: BillProcessingStatus[];
    verification: 'verified' | 'unverified' | null;
    utilities: string[];
}

export const emptyBillSidebarFilters: IBillSidebarFilters = {
    period: null,
    statuses: [],
    verification: null,
    utilities: [],
};

export const getBillPeriodRange = (period: string | null): { start: string; end: string } | null => {
    if (!period) return null;
    const key = period.split('::')[0];
    const fmt = 'YYYY-MM-DD';
    switch (key) {
        case 'current_month':
            return { start: dayjs().startOf('month').format(fmt), end: dayjs().endOf('month').format(fmt) };
        case 'current_quarter':
            return { start: dayjs().startOf('quarter').format(fmt), end: dayjs().endOf('quarter').format(fmt) };
        case 'previous_month':
            return {
                start: dayjs().subtract(1, 'month').startOf('month').format(fmt),
                end: dayjs().subtract(1, 'month').endOf('month').format(fmt),
            };
        case 'previous_quarter':
            return {
                start: dayjs().subtract(1, 'quarter').startOf('quarter').format(fmt),
                end: dayjs().subtract(1, 'quarter').endOf('quarter').format(fmt),
            };
        case 'custom_range': {
            const raw = period.split('::')[1];
            if (!raw) return null;
            const [s, e] = raw.split('_');
            if (!s || !e) return null;
            return { start: dayjs(s).format(fmt), end: dayjs(e).format(fmt) };
        }
        default:
            return null;
    }
};

export const countActiveBillFilters = (filters: IBillSidebarFilters): number =>
    filters.statuses.length + filters.utilities.length + (filters.period ? 1 : 0) + (filters.verification ? 1 : 0);
